import {
  COMPARATIVE_TABLE_DATA,
  LOADER_STATUS,
  PREVIEW_TABLE_DATA,
  SAVE_TABLE_DATA,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  previewTableData: [],
  saveTableData: [],
  comparativeTableData: [],
};

/* eslint-disable default-case, no-param-reassign */
const gstr1NewSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case PREVIEW_TABLE_DATA:
      return {
        ...state,
        previewTableData: action.previewTableData,
      };
    case SAVE_TABLE_DATA:
      return {
        ...state,
        saveTableData: action.saveTableData,
      };
    case COMPARATIVE_TABLE_DATA:
      return {
        ...state,
        comparativeTableData: action.comparativeTableData,
      };
    default:
      return state;
  }
};

export default gstr1NewSaveReducer;
